function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj);
}
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols);
} return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); });
} return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
}
else {
    obj[key] = value;
} return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null)
    return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object")
        return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return (hint === "string" ? String : Number)(input); }
import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    data: [],
    available: []
};
function balanceCurrencyResource(data) {
    var broker = {
        id: data.broker.id,
        name: data.broker.name,
        separator: data.broker.separator,
        hasUniqueTradeId: data.broker.hasUniqueTradeId
    };
    return {
        id: data.id,
        name: data.name,
        convert: data.convert,
        broker: broker,
        unique: data.unique
    };
}
export var BalanceCurrencyReducer = createSlice({
    name: 'balancesCurrency',
    initialState: initialState,
    reducers: {
        set: function set(state, balancesCurrency) {
            var data = [];
            balancesCurrency.payload.forEach(function (item) {
                data[item.id] = balanceCurrencyResource(item);
            });
            state.data = data;
        },
        setAvailable: function setAvailable(state, balancesCurrency) {
            state.available = balancesCurrency.payload;
        },
        clearAvailable: function clearAvailable(state) {
            state.available = [];
        },
        add: function add(state, balanceCurrency) {
            if (balanceCurrency.payload.unique) {
                state.data.push(balanceCurrencyResource(balanceCurrency.payload));
                return;
            }
            state.data.push(balanceCurrencyResource(balanceCurrency.payload));
        },
        update: function update(state, balanceCurrency) {
            state.data[balanceCurrency.payload.id] = balanceCurrencyResource(balanceCurrency.payload);
        },
        makeUnique: function makeUnique(state, balanceCurrency) {
            state.data = state.data.map(function (item) {
                if (item.id === balanceCurrency.payload.id) {
                    return balanceCurrency.payload;
                }
                if (item.broker.id === balanceCurrency.payload.broker.id) {
                    return _objectSpread(_objectSpread({}, item), {}, {
                        unique: false
                    });
                }
                return item;
            });
        },
        del: function del(state, balanceCurrency) {
            state.data = state.data.filter(function (item) {
                return item.id !== balanceCurrency.payload;
            });
        }
    }
});
var _BalanceCurrencyReduc = BalanceCurrencyReducer.actions, add = _BalanceCurrencyReduc.add, set = _BalanceCurrencyReduc.set, setAvailable = _BalanceCurrencyReduc.setAvailable, clearAvailable = _BalanceCurrencyReduc.clearAvailable, update = _BalanceCurrencyReduc.update, del = _BalanceCurrencyReduc.del, makeUnique = _BalanceCurrencyReduc.makeUnique;
export { add, set, setAvailable, clearAvailable, update, del, makeUnique };
export default BalanceCurrencyReducer.reducer;
